<style scoped>
.pink-msg-box {
    border-width: 2px;
    border-color: #ff0000;
    background: #ffcccc;
}

.summary-info-table tr td:nth-child(2) {
    max-width: calc(100vw - 8rem);
}

.product-table ::v-deep .sale-catg-group-header-right-area {
    @apply flex items-center;

    & .tooltip {
        position: relative;
        display: inline-block;
    }

    & .tooltip .tooltiptext {
        font-size: 0.75rem;
        visibility: hidden;
        width: 110px;
        color: black;
        background-color: #fff2cc;
        border-color: #ffbf00;
        border-width: 1px;
        text-align: center;
        padding: 5px 0;

        position: absolute;
        top: -10px;
        z-index: 1;
        top: 115%;
        right: -30%;

        @apply font-normal;
    }

    & .tooltip:hover .tooltiptext {
        visibility: visible;
    }
}

@screen md {
    .product-table {
        @apply pl-2;
    }
    .product-table ::v-deep thead {
        padding-right: 17px; /* scrollbar width */
    }
    .product-table ::v-deep tbody {
        overflow-y: scroll;
        height: 700px;
    }
}

.reminder-message {
    background: rgba(255, 242, 204, 1);
    @apply border border-primary m-3 px-8 py-2 font-semibold;

    & ul {
        counter-reset: item;
        @apply font-bold list-outside list-disc;
    }

    & a {
        @apply text-blue underline;
    }
}
</style>

<template>
    <div class="max-w-site mx-auto">
        <breadcrumb class="mt-4" :links="[{ msg: 'cart.cart' }]" />
        <pageLoader v-if="!pageLoaded" />
        <div v-if="pageLoaded && cartEmpty" class="flex flex-col items-center">
            <div class="text-3xl font-bold">
                {{ $t('cart.no.item') }}
            </div>
            <router-link
                to="/"
                tag="button"
                class="btn border-0 font-black text-secondary flex items-center mt-2 mb-6"
            >
                <div class="icon">
                    <chevronLeft />
                </div>
                {{ $t('cart.continue.shopping') }}
            </router-link>
            <msgSlot msgKey="cart.go.to.order.history">
                <template #slot0>
                    <router-link
                        tag="button"
                        to="/account/orderHistory"
                        class="font-black underline text-secondary"
                    >
                        {{ $t('common.here') }}
                    </router-link>
                </template>
                <template #slot1>
                    <router-link
                        tag="button"
                        to="/account/orderHistory"
                        class="font-black underline text-secondary"
                    >
                        {{ $t('order.history') }}
                    </router-link>
                </template>
            </msgSlot>
        </div>

        <div
            class="flex flex-col md:flex-row md:flex-wrap"
            v-if="pageLoaded && list.length"
        >
            <div class="w-full md:w-2/3 border border-primary">
                <div class="w-full text-center text-lg font-bold my-4">
                    {{ $t('cart.greet') }}
                </div>
                <div
                    v-if="isFriendCustomer && excessFriendAccountMaxProdOrdQty"
                    class="flex flex-col items-center sm:flex-row sm:justify-between pink-msg-box mx-1 sm:mx-8 p-4"
                >
                    <div>
                        <div>
                            親友會員最多可購買 10 款貨品
                        </div>
                        <div>
                            成為企業會員，可以購買更多貨品
                        </div>
                    </div>
                    <howToBecomeEnterpriseMemberModalButton
                        btnClass="btn btn-primary"
                    />
                </div>
                <div
                    class="w-full flex flex-col items-center text-red"
                    v-if="!cartCanProcess"
                >
                    <div class="text-base font-bold">
                        {{ $t('cart.error.some.products.excess.qty') }}
                    </div>
                    <div
                        class="text-sm underline cursor-pointer"
                        @click="updateAllExcessQtyProducts"
                    >
                        {{ $t('cart.adjust.cart.qty') }}
                    </div>
                </div>
                <productTable
                    :list="list"
                    :groupByCategory="true"
                    :dsctAmt="cpnDsctAmt + adhocDsctAmt + crdtPntDsctAmt"
                    :crdtPntEarnAmt="crdtPntEarn"
                    :showCrdtPntEarnAmt="false"
                    @deleteProduct="deleteProductPrompt"
                    @prodOrdQtyChanged="productOrderQtyChanged"
                    :rightInfoList="
                        deliveryDate
                            ? [
                                  {
                                      label: $t('order.delivery.date'),
                                      desp: formatDate(deliveryDate, 'fulldate')
                                  }
                              ]
                            : []
                    "
                    :showSummary="false"
                    class="product-table w-full mt-4"
                >
                    <template #groupHeaderRightArea="{saleCatgSlctCode}">
                        <div
                            v-if="saleCatgCanEarnTcoin(saleCatgSlctCode)"
                            class="icon text-primary tooltip mr-2"
                        >
                            <tryhalaCoinSvg />
                            <span class="tooltiptext" style="line-height:1.5">
                                {{ $t('cart.saleCatg.tcoin.tooltip') }}
                            </span>
                        </div>
                        <div
                            v-if="saleCatgCanEarnLuckyDraw(saleCatgSlctCode)"
                            class="tooltip"
                        >
                            <img class="w-5 h-5" :src="imgPrmtEvntGiftIcon" />
                            <span class="tooltiptext">
                                {{ $t('cart.saleCatg.luckydraw.tooltip') }}
                            </span>
                        </div>
                    </template>
                </productTable>
            </div>

            <div
                class="w-full md:flex md:flex-col md:w-1/3 md:pl-4"
                ref="dlvrySiteAndPaymentSelection"
            >
                <div
                    class="flex flex-col items-center border border-primary mt-4 md:mt-0 mb-4 py-4 text-lg"
                    v-if="haveDlvryProd"
                >
                    <div class="font-bold">請選擇取貨地點</div>
                    <div class="w-full flex flex-row items-start mt-2 px-8">
                        <div class="w-1/3">取貨地點:</div>
                        <deliveryAddressSelection
                            class="w-2/3"
                            v-model.number="dlvryCmpySiteKey"
                            :disabled="isFriendCustomer"
                            :showDlvryCmpySiteAddr="showDlvryCmpySiteAddr"
                        />
                    </div>
                    <div v-if="isFriendCustomer" class="mt-2 text-xs text-blue">
                        (取貨地點只能由相關的企業會員更改)
                    </div>
                </div>
                <div
                    v-if="haveMchtDlvrProd"
                    class="flex flex-col flex-grow items-center border border-primary mt-4 mb-4 md:mt-0 py-4 px-2 text-lg"
                >
                    <div class="font-bold">商戶直送</div>
                    <div class="px-2">
                        您的購物車有商戶直送貨品。請提供聯絡資料，商戶將會直接與您聯絡安排送貨。
                    </div>
                    <div class="px-2 mt-2">
                        <formFieldRowByRule
                            name="cntcName"
                            :label="$t('cart.dlvr.name')"
                            :errors="errors"
                            :rules="validationRules"
                        >
                            <input
                                class="form-input w-full"
                                :class="{ 'border-red': hasError }"
                                v-model.trim="custDlvrAddrForm.cntcName"
                            />
                        </formFieldRowByRule>
                        <formFieldRowByRule
                            name="cntcPhoneNum"
                            :label="$t('cart.dlvr.phoneNum')"
                            :errors="errors"
                            :rules="validationRules"
                        >
                            <input
                                class="form-input w-full"
                                :class="{ 'border-red': hasError }"
                                type="tel"
                                v-model.trim="custDlvrAddrForm.cntcPhoneNum"
                            />
                        </formFieldRowByRule>
                        <formFieldRow
                            name="cntcImPhoneNum"
                            :label="$t('cart.dlvr.im.wts')"
                            :errors="errors"
                        >
                            <input
                                class="form-input w-full"
                                :class="{ 'border-red': hasError }"
                                v-model.trim="custDlvrAddrForm.cntcImPhoneNum"
                            />
                        </formFieldRow>
                        <formFieldRow
                            name="cntcEmailAddr"
                            :label="$t('cart.dlvr.emailAddr')"
                            :errors="errors"
                        >
                            <input
                                class="form-input w-full"
                                :class="{ 'border-red': hasError }"
                                maxlength="50"
                                v-model.trim="custDlvrAddrForm.cntcEmailAddr"
                            />
                        </formFieldRow>
                        <formFieldRowByRule
                            name="dlvrAddrLine1Text"
                            :label="$t('cart.dlvr.addrLine1')"
                            :errors="errors"
                            :rules="validationRules"
                        >
                            <input
                                class="form-input w-full"
                                :class="{ 'border-red': hasError }"
                                maxlength="50"
                                v-model.trim="
                                    custDlvrAddrForm.dlvrAddrLine1Text
                                "
                            />
                        </formFieldRowByRule>
                        <formFieldRow
                            name="dlvrAddrLine2Text"
                            :label="$t('cart.dlvr.addrLine2')"
                            :errors="errors"
                        >
                            <input
                                class="form-input w-full"
                                :class="{ 'border-red': hasError }"
                                maxlength="50"
                                v-model.trim="
                                    custDlvrAddrForm.dlvrAddrLine2Text
                                "
                            />
                        </formFieldRow>
                        <formFieldRowByRule
                            name="geogAreaSlctKey"
                            :label="$t('cart.dlvr.geogArea')"
                            :errors="errors"
                            :rules="validationRules"
                        >
                            <template #default="{ hasError }">
                                <select
                                    class="form-select"
                                    :class="{ 'border-red': hasError }"
                                    v-model.trim="
                                        custDlvrAddrForm.geogAreaSlctKey
                                    "
                                >
                                    <option disabled :value="null"> </option>
                                    <option
                                        v-for="s in geogAreaList"
                                        :key="s.id"
                                        :value="s.id"
                                    >
                                        {{ $t(s.slctDesp) }}
                                    </option>
                                </select>
                            </template>
                        </formFieldRowByRule>
                        <formFieldRow
                            name="rmkText"
                            :label="$t('cart.dlvr.rmk')"
                            :errors="errors"
                        >
                            <textarea
                                style="height: 100px"
                                maxlength="100"
                                class="form-input w-full"
                                :class="{ 'border-red': hasError }"
                                v-model.trim="custDlvrAddrForm.rmkText"
                            />
                        </formFieldRow>
                    </div>
                </div>
                <div
                    v-if="needPayment"
                    class="flex flex-col flex-grow items-center border border-primary mt-4 md:mt-0 py-4 px-2 text-lg"
                >
                    <div class="font-bold">
                        請選擇付款方式
                    </div>
                    <paymentSelection
                        ref="paymentSelection"
                        class="flex-grow"
                        :hiddenProviders="canPayCash ? [] : ['CASH']"
                        :disabledProviders="disabledPaymentMethodList"
                        @paymentSelected="v => (paymentOption = v)"
                    />
                </div>
            </div>

            <div
                class="w-full py-4 flex flex-col md:w-2/3 border border-t-0 border-primary"
            >
                <div class="w-full flex flex-col md:flex-row md:flex-wrap">
                    <div class="flex flex-col flex-wrap p-2">
                        <div
                            v-if="$config.displayCreditPointLayout()"
                            class="flex flex-row flex-wrap items-start py-2 text-sm"
                        >
                            <checkbox
                                :value="useCreditPoint"
                                @input="setUseCreditPoint"
                                :disabled="!$config.enableCreditPoint()"
                                class="w-40 checkbox-sm"
                            >
                                <div class="flex flex-col">
                                    <msgSlot
                                        msgKey="cart.use.msg.slot"
                                        class="inline-flex items-center"
                                    >
                                        <template #slot0>
                                            <div>
                                                {{ $t('credit.point.name') }}
                                            </div>
                                            <div class="icon text-primary ml-1">
                                                <tryhalaCoinSvg />
                                            </div>
                                        </template>
                                    </msgSlot>
                                </div>
                            </checkbox>

                            <div class="flex-col md:mt-0">
                                <div class="flex items-center">
                                    <div
                                        class="border border-r-0 border-gray-100 rounded-l px-2"
                                        :class="
                                            useCreditPoint ? '' : 'bg-gray-100'
                                        "
                                    >
                                        {{ '$' }}
                                    </div>
                                    <input
                                        class="border border-l-0 border-gray-100 rounded-r w-16 text-center focus:outline-none"
                                        type="number"
                                        :step="spendCrdtPntUnitDsctAmt"
                                        min="0"
                                        :max="maxCrdtPntDsctAmt"
                                        :disabled="!useCreditPoint"
                                        v-model.number.lazy="crdtPntDsctAmt"
                                    />
                                    <msgSlot
                                        v-if="crdtPntAmt > 0"
                                        msgKey="{0}個{1}"
                                        class="inline-flex items-center ml-2 text-base"
                                    >
                                        <template #slot0>{{
                                            crdtPntAmt | numberWithCommas
                                        }}</template>
                                        <template #slot1>
                                            <div class="icon text-primary ml-1">
                                                <tryhalaCoinSvg />
                                            </div>
                                        </template>
                                    </msgSlot>
                                </div>

                                <msgSlot
                                    msgKey="credit.point.max.qty"
                                    class="inline-flex items-center mt-0 text-sm"
                                >
                                    <template #slot0>
                                        {{ maxCrdtPnt | numberWithCommas }}
                                    </template>
                                    <template #slot1>
                                        <div class="icon text-primary ml-1">
                                            <tryhalaCoinSvg />
                                        </div>
                                    </template>
                                </msgSlot>
                                <div class="text-red text-base">
                                    {{ crdtPntErrMsg }}
                                </div>
                            </div>
                        </div>
                        <div
                            v-for="(m, mi) in adhocDsctMsgs"
                            :key="mi"
                            class="flex items-center"
                            :class="m.class"
                        >
                            <infoSvg class="mr-2 fill-current" />
                            <component :is="m.component" />
                        </div>
                    </div>
                    <productTableSummaryInfo
                        :list="list"
                        :dsctAmt="cpnDsctAmt + adhocDsctAmt + crdtPntDsctAmt"
                        :showCrdtPntEarnAmt="$config.displayCreditPointLayout()"
                        :crdtPntEarnAmt="crdtPntEarn"
                        class="summary-info-table ml-auto"
                    >
                    </productTableSummaryInfo>
                </div>
                <div class="ml-auto mr-4 flex flex-col items-center mt-4">
                    <loadingButton
                        class=" btn btn-primary self-end py-2 font-bold mt-1 px-4"
                        :class="{
                            'opacity-50':
                                hasError ||
                                !cartCanProcess ||
                                (isFriendCustomer &&
                                    excessFriendAccountMaxProdOrdQty)
                        }"
                        :disabled="
                            hasError ||
                                !cartCanProcess ||
                                (isFriendCustomer &&
                                    excessFriendAccountMaxProdOrdQty)
                        "
                        :status="status"
                        @click="requestConfirmOrder"
                    >
                        {{ $t('order.confirm') }}
                    </loadingButton>
                    <errorBox
                        v-if="errors && errors.server"
                        :message="errors.server"
                    />
                    <div
                        v-if="hasError"
                        class="flex items-center justify-between sm:justify-end text-red"
                    >
                        {{ $t('cart.error.reload') }}
                    </div>
                    <confirmOrderModal
                        v-if="showConfirmOrder"
                        :paymentOption="paymentOption"
                        :needPayment="needPayment"
                        @confirm="confirmOrder"
                        @cancel="showConfirmOrder = false"
                    />
                </div>
                <div class="reminder-message">
                    <!-- <span>注意: 按下確認付款後便會轉</span>
                        <span>跳到您所選擇的付款⽅式介面</span> -->
                    <span>請注意： </span>
                    <ul>
                        <li>
                            按下確認付款後將會轉跳到您所選擇的付款介面
                        </li>
                        <li>
                            我們將發送電子收據至您的電郵地址。請把我們的系統電郵地址
                            <a href="mailto:cs@tryhala.com">cs@tryhala.com</a>
                            加入為聯絡人，以免您的電郵系統誤當為垃圾郵件
                        </li>
                        <li>
                            若有任何查詢，請電郵至
                            <a href="mailto:cs@tryhala.com">cs@tryhala.com</a>
                        </li>
                    </ul>
                </div>
            </div>
            <modal type="custom" v-if="orderStatusModalMsg">
                {{ orderStatusModalMsg }}
            </modal>
            <modal
                v-if="showDelete"
                @cancel="() => (showDelete = false)"
                @confirm="doDelete"
            >
                {{ $t('cart.confirm.remove', deleteProduct.prodName) }}
            </modal>

            <modal
                v-if="showDeliverySiteOrPaymentNotSelectedModal"
                type="alert"
                :showCancel="false"
                @confirm="showDeliverySiteOrPaymentNotSelectedModal = false"
                @backdrop="showDeliverySiteOrPaymentNotSelectedModal = false"
                :confirmText="$t('common.confirm')"
            >
                <div class="w-full text-center text-xl font-black">
                    {{ '請選擇付款方式 及 取貨地點' }}
                </div>
            </modal>
            <modal
                type="alert"
                v-if="createPaymentFail"
                :showCancel="false"
                @confirm="redirectToOrderHistory(salesOrder.saleOrdTxnNum)"
            >
                {{ $t('cart.error.payment.error') }}
            </modal>
            <accountInfoFormModal
                v-if="showInfoModal"
                @success="infoSaveSuccess"
                @hide="() => (showInfoModal = false)"
            />
        </div>
    </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb.vue';
import price from '@/components/priceFilter';
import modal from '@/components/modal.vue';
import formatDate from '@/components/formatDateFilter';
import { mapGetters } from 'vuex';
import productTable from '@/components/productTable.vue';
import pageLoader from '@/components/pageLoader.vue';
import accountInfoFormModal from '@/components/accountInfoFormModal.vue';
import loadingButton from '@/components/loadingButton.vue';
import checkbox from '@/components/checkbox.vue';
import msgSlot from '@/components/msgSlot';
import infoSvg from '@/assets/svg/info_outline.svg';
import tryhalaCoinSvg from '@/assets/svg/tryhala_coin.svg';
import img1s112 from '@/assets/img/1-112.png';
import numberWithCommas from '@/components/numberWithCommasFilter';
import paymentSelection from '@/components/paymentSelection.vue';
import deliveryAddressSelection from '../../components/deliveryAddressSelection.vue';
import productTableSummaryInfo from '../../components/productTableSummaryInfo.vue';
import { createForm } from '@/utils/formUtil';
import errorBox from '../../components/errorBox.vue';
import chevronLeft from '../../assets/svg/chevron_left.svg';
import contentNewLine from '../../components/contentNewLine';
import uniq from 'lodash/uniq';
import howToBecomeEnterpriseMemberModalButton from '../../components/howToBecomeEnterpriseMemberModalButton.vue';
import confirmOrderModal from '../../components/confirmOrderModal';
import imgPrmtEvntGiftIcon from '@/assets/img/promotion_event_gift_icon.png';
import formFieldRow from '@/components/formFieldRow.vue';
import formFieldRowByRule from '@/components/formFieldRowByRule.vue';
import { validate } from '@/utils/validationUtil';
import { instance } from '@/utils/ajax';

async function getProdPymtMthdByIdList(idList) {
    try {
        let result = await instance.post(
            '/api/prodPymtMthd/getProdPymtMthdByIdList',
            idList
        );
        return result.data;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error getting product payment method info');
    }
    return undefined;
}

const validationRules = {
    cntcName: { required: true, show: true },
    cntcPhoneNum: {
        required: true,
        show: true,
        checked: cntcPhoneNum => {
            if (!/^\d{8}$/.test(cntcPhoneNum)) {
                return 'error.phone.format.mobile';
            }
        }
    },
    cntcImPhoneNum: {
        checked: cntcImPhoneNum => {
            if (cntcImPhoneNum && !/^\d{8}$/.test(cntcImPhoneNum)) {
                return 'error.phone.format.mobile';
            }
        }
    },
    dlvrAddrLine1Text: { required: true },
    geogAreaSlctKey: { required: true }
};

export default {
    components: {
        breadcrumb,
        modal,
        productTable,
        pageLoader,
        accountInfoFormModal,
        loadingButton,
        checkbox,
        msgSlot,
        infoSvg,
        tryhalaCoinSvg,
        paymentSelection,
        deliveryAddressSelection,
        productTableSummaryInfo,
        errorBox,
        chevronLeft,
        contentNewLine,
        howToBecomeEnterpriseMemberModalButton,
        confirmOrderModal,
        formFieldRow,
        formFieldRowByRule
    },
    filters: { price, numberWithCommas },
    data() {
        const u = this.$store.state.user;
        const csList = this.$store.state.companySiteList;

        return {
            pageLoaded: false,
            showDelete: false,
            deleteProduct: undefined,
            status: undefined,
            hasError: false,
            showInfoModal: false,
            infoErrors: {},
            img1s112: img1s112,
            productOrderQtyChangedTimeout: undefined,
            siteList: csList.map(i => ({
                cmpySiteName: i.cmpySiteName,
                cmpySiteAddr: i.cmpySiteAddr,
                id: i.id
            })),
            errors: {},
            salesOrder: undefined,
            dlvryCmpySiteKey: u.cmpySiteKey,
            showDlvryCmpySiteAddr: u.custTypeCode === 'PUB',
            paymentOption: undefined,
            showConfirmOrder: false,
            orderStatusModalMsg: undefined,
            showDeliverySiteOrPaymentNotSelectedModal: false,
            createPaymentFail: false,
            imgPrmtEvntGiftIcon: imgPrmtEvntGiftIcon,
            custDlvrAddrForm: {
                cntcName: [
                    this.$store.state.user.custLastName,
                    this.$store.state.user.custFrstName
                ]
                    .join(' ')
                    .trim(),
                cntcPhoneNum: this.$store.state.user.custPhoneNum,
                cntcEmailAddr: this.$store.state.user.custEmailAddr,
                rmkText: undefined,
                cntcImPhoneNum: undefined,
                cntcImTypeCode: 'WTS',
                dlvrAddrLine1Text: undefined,
                dlvrAddrLine2Text: undefined,
                geogAreaSlctKey: null
            },
            prodPymtMthdList: undefined
        };
    },
    async created() {
        this.formatDate = formatDate;
        this.pageLoaded = false;
        this.shoppingCartList = await this.$store.dispatch(
            'getShoppingCartList'
        );
        if (!this.shoppingCartList) {
            this.$router.push({ name: 'pageNotFound' });
            return;
        }
        this.$store.dispatch('getCouponList');
        this.$store.dispatch('getCreditPointBalance');
        const result = await getProdPymtMthdByIdList(this.cartItemProdKeyList);
        if (result.success) {
            this.prodPymtMthdList = result.data.prodPymtMthdList;
        }
        this.pageLoaded = true;
    },
    computed: {
        list() {
            return this.$store.state.cartItems;
        },
        cpnList() {
            return this.$store.state.cpnList;
        },
        crdtPntBal() {
            return this.$store.state.crdtPntBal;
        },
        rcvCrdtPntUnitPchsAmt() {
            return this.$store.getters.rcvCrdtPntUnitPchsAmt;
        },
        rcvCrdtPntUnitQty() {
            return this.$store.getters.rcvCrdtPntUnitQty;
        },
        spendCrdtPntUnitDsctAmt() {
            return this.$store.getters.spendCrdtPntUnitDsctAmt;
        },
        hasCoupon() {
            return this.cpnList && this.cpnList.length > 0;
        },
        useCoupon() {
            return this.$store.state.useCoupon;
        },
        useCreditPoint() {
            return this.$store.state.useCreditPoint;
        },
        cpn: {
            get: function() {
                return this.$store.state.cpn;
            },
            set: function(cpn) {
                this.$store.commit('setCpn', cpn);
            }
        },
        crdtPntDsctAmt: {
            get: function() {
                return this.$store.getters.crdtPntDsctAmt;
            },
            set: function(amt) {
                const upperbound = this.maxCrdtPntDsctAmt;
                const val = Math.min(Math.max(amt || 0, 0), upperbound);
                this.$store.dispatch('updateCreditPointDiscountAmount', {
                    crdtPntDsctAmt: val
                });
            }
        },
        crdtPntEarn() {
            return this.$store.getters.crdtPntEarn(this.list);
        },
        maxCrdtPnt() {
            return this.$store.getters.maxCrdtPnt(this.list);
        },
        maxCrdtPntDsctAmt() {
            return this.$store.getters.maxCrdtPntDsctAmt(this.list);
        },
        cpnErrMsg() {
            if (this.useCoupon) {
                if (!this.cpn) {
                    return `*${this.$t('cart.coupon.please.select')}`;
                } else if (this.cpnDsctAmt > this.sampleProdTotalPrice) {
                    return `*${this.$t(
                        'cart.coupon.amt.less.than.totalPrice'
                    )}`;
                }
            }
            return '';
        },
        crdtPntErrMsg() {
            if (
                this.useCreditPoint &&
                this.crdtPntDsctAmt > this.maxCrdtPntDsctAmt
            ) {
                return `*${this.$t(
                    'cart.credit.point.more.than.amt.after.dsct',
                    this.crdtPntAmt
                )}`;
            }
            return '';
        },
        cpnDsctAmt() {
            return this.$store.getters.cpnDsctAmt;
        },
        adhocDsctAmt() {
            return this.$store.getters.adhocDsctAmt;
        },
        adhocDsctMsgs() {
            return this.$store.getters.adhocDsctMsgs;
        },
        crdtPntAmt() {
            return this.$store.getters.crdtPntAmt;
        },
        deliveryDate() {
            return this.$store.getters.shoppingList.schdDlvrDate;
        },
        sampleProdTotalPrice() {
            return this.$store.getters.cartSmplTotalPrice;
        },
        standardProdTotalPrice() {
            return this.$store.getters.cartStdTotalPrice;
        },
        cartCanProcess() {
            if (this.crdtPntDsctAmt > this.maxCrdtPntDsctAmt) {
                return false;
            }
            return this.$store.getters.cartCanProcess;
        },
        excessFriendAccountMaxProdOrdQty() {
            const friendAccountMaxProdKinds = this.$store.state
                .friendAccountMaxProdKinds;
            const purchasedProductKeys = this.$store.state.purchasedProductKeys;

            const uniqueProdKeys = uniq(
                purchasedProductKeys.concat(this.list.map(i => i.prodKey))
            );

            return uniqueProdKeys.length > friendAccountMaxProdKinds;
        },
        isFriendCustomer() {
            return this.$store.getters.isFriendCustomer;
        },
        needPayment() {
            return this.$store.getters.cartTotalPriceAfterAllDsct > 0;
        },
        cmpySiteAddr() {
            return cmpySiteKey =>
                this.siteList.find(s => s.id === cmpySiteKey)?.cmpySiteAddr;
        },
        canPayCash() {
            const saleCatgPayCashMap = this.$store.state.saleCatgPayCashMap;
            return this.list.every(
                prod => saleCatgPayCashMap?.[prod.saleCatgSlctCode] === 'Y'
            );
        },
        saleCatgCanEarnTcoin() {
            return saleCatgSlctCode =>
                this.$store.state.saleCatgUseTcoinMap?.[saleCatgSlctCode] ===
                'Y';
        },
        saleCatgCanEarnLuckyDraw() {
            return saleCatgSlctCode =>
                this.$store.state.luckydraw2021IndMap?.[saleCatgSlctCode] ===
                'Y';
        },
        haveDlvryProd() {
            return (
                this.list.filter(
                    product =>
                        product.prodSaleArngCode !== 'MCHT_DLVR' &&
                        product.prodTypeCode !== 'VRTL'
                ).length > 0
            );
        },
        haveMchtDlvrProd() {
            return (
                this.list.filter(
                    product => product.prodSaleArngCode === 'MCHT_DLVR'
                ).length > 0
            );
        },
        validationRules() {
            return validationRules;
        },
        geogAreaList() {
            return this.$store.state.geogAreaList;
        },
        ...mapGetters(['cartEmpty']),
        cartItemProdKeyList() {
            return this.$store.state.cartItems.map(item => item.prodKey);
        },
        disabledPaymentMethodList() {
            const validPaymentMethodList = this.prodPymtMthdList.filter(p =>
                this.cartItemProdKeyList.some(pk => pk === p.prodKey)
            );
            const nonUniqueDisabledList = validPaymentMethodList.filter(
                p => p.pymtCustTypeCode === 'DSBL'
            );
            let list = [];
            nonUniqueDisabledList.forEach(p => {
                const prod = this.list.find(item => item.prodKey === p.prodKey);
                const message =
                    (prod?.prodBrndName || '') +
                    ' ' +
                    prod?.prodName +
                    ' ' +
                    (prod?.prodSizeText || '');
                const matchedPymtMthdInList = list.find(
                    m =>
                        m.pymtSrvcPrvdId === p.pymtSrvcPrvdId &&
                        m.pymtMthdId === p.pymtMthdId
                );
                if (matchedPymtMthdInList) {
                    matchedPymtMthdInList.messages.push(message);
                    return;
                }
                const data = {
                    pymtSrvcPrvdId: p.pymtSrvcPrvdId,
                    pymtMthdId: p.pymtMthdId,
                    messages: [message]
                };
                list.push(data);
            });
            return list;
        }
    },
    methods: {
        scrollToDlvrySiteAndPaymentSelection() {
            this.$refs.dlvrySiteAndPaymentSelection.scrollIntoView();
        },
        deleteProductPrompt(p) {
            this.deleteProduct = p;
            this.showDelete = true;
        },
        setUseCoupon(val) {
            this.$store.commit('setUseCoupon', val);
        },
        setUseCreditPoint(val) {
            this.$store.commit('setUseCreditPoint', val);
        },
        productOrderQtyChanged(prod, qty) {
            clearTimeout(this.productOrderQtyChangedTimeout);

            this.productOrderQtyChangedTimeout = setTimeout(() => {
                this.updateDbProdOrdQty(prod, qty);
            }, 700);
        },
        async updateDbProdOrdQty(prod, qty) {
            let cartProd = await this.$store.dispatch(
                'insertUpdateServerCart',
                {
                    shopListProdKey: prod.shopListProdKey,
                    prodOrdQty: qty
                }
            );
            if (!cartProd) {
                this.hasError = true;
            }
        },
        async updateAllExcessQtyProducts() {
            let success = await this.$store.dispatch(
                'updateOrRemoveExcessMaxQtyCartProduct'
            );
            if (!success) {
                this.hasError = true;
            }
        },
        async doDelete() {
            let success = await this.$store.dispatch(
                'deleteCartProduct',
                this.deleteProduct.id
            );
            if (!success) {
                this.hasError = true;
            }
            this.showDelete = false;
            this.deleteProduct = undefined;
        },
        async requestConfirmOrder() {
            if (
                (this.needPayment && !this.paymentOption) ||
                !this.dlvryCmpySiteKey
            ) {
                this.scrollToDlvrySiteAndPaymentSelection();
                this.showDeliverySiteOrPaymentNotSelectedModal = true;
                return;
            }

            if (this.haveMchtDlvrProd) {
                this.custDlvrAddrForm.cntcPhoneNum = this.custDlvrAddrForm.cntcPhoneNum?.replace(
                    /\s/g,
                    ''
                );
                this.custDlvrAddrForm.cntcImPhoneNum = this.custDlvrAddrForm.cntcImPhoneNum?.replace(
                    /\s/g,
                    ''
                );
                const v = validate(
                    this.errors,
                    this.custDlvrAddrForm,
                    this.validationRules
                );
                if (v.hasError) {
                    this.scrollToDlvrySiteAndPaymentSelection();
                    this.status = undefined;
                    this.orderStatusModalMsg = undefined;
                    this.errors = v.errors;
                    return;
                }
            }

            const isInfoCompleted = await this.$store.dispatch(
                'getIsAccountInfoCompleted'
            );
            if (!isInfoCompleted) {
                this.status = undefined;
                this.showInfoModal = true;
                return;
            }

            this.showConfirmOrder = true;
        },
        async confirmOrder() {
            this.showConfirmOrder = false;
            this.orderStatusModalMsg = this.$t('order.creating');
            this.status = 'loading';

            this.errors = {};

            const result = await this.$store.dispatch('createOrder', {
                shopCarts: this.$store.state.cartItems,
                cmpySiteKey: this.dlvryCmpySiteKey,
                cpnKey: this.useCoupon ? this.cpn.id : null,
                spendCrdtPntQty: this.crdtPntAmt,
                custDlvrAddrForm: this.haveMchtDlvrProd
                    ? this.custDlvrAddrForm
                    : null
            });

            this.status = undefined;

            if (result.success) {
                this.salesOrder = result.data.salesOrder;
                this.$store.commit('setUser', result.data.user);

                if (this.needPayment) {
                    await this.requestPayment(this.paymentOption);
                } else {
                    this.redirectToOrderHistory(this.salesOrder.saleOrdTxnNum);
                }
            } else {
                this.orderStatusModalMsg = undefined;
                this.errors = result.data.errors;

                if (result.data.errShoppingCarts) {
                    for (var errShopCart of result.data.errShoppingCarts) {
                        let matchCart = this.$store.state.cartItems.find(
                            c =>
                                c.shopListProdKey ===
                                errShopCart.shopListProdKey
                        );
                        if (matchCart) {
                            matchCart.rmnProdQty = errShopCart.rmnProdQty;
                            matchCart.totalBoughtQty =
                                errShopCart.totalBoughtQty;
                            matchCart.stckAvailQty = errShopCart.stckAvailQty;
                        }
                    }
                }
            }
        },
        async requestPayment(paymentOption) {
            this.orderStatusModalMsg = this.$t('order.redirect.to.payment');

            // Create Payment
            const createPaymentResponse = await this.$store.dispatch(
                'createPayment',
                {
                    saleOrdTxnNum: this.salesOrder.saleOrdTxnNum,
                    pymtSrvcPrvdId: this.paymentOption.pymtSrvcPrvdId,
                    pymtMthdId: this.paymentOption.pymtMthdId
                }
            );

            if (createPaymentResponse.success) {
                if (paymentOption.pymtSrvcPrvdId === 'CASH') {
                    //Redirect to Review Order
                    this.redirectToOrderHistory(this.salesOrder.saleOrdTxnNum);
                } else if (paymentOption.pymtSrvcPrvdId === 'HSBC') {
                    /* eslint-disable no-console */
                    console.log('HSBC');

                    // Refresh Shopping Cart
                    this.$store.dispatch('getShoppingCartList');
                    this.$store.commit('setFpsData', {
                        fpsQrCode: createPaymentResponse.data.qrCode,
                        fpsCurrentOrdNo: this.salesOrder.saleOrdTxnNum,
                        fpsCurrentOrdKey: this.salesOrder.id,
                        fpsPymtAmt: this.salesOrder.pymtTotAmt
                    });
                    this.$router.push({ name: 'fps' });
                } else {
                    //Redirect to Payment Gateway
                    let form = createForm(
                        'POST',
                        createPaymentResponse.data.paymentUrl,
                        createPaymentResponse.data.formBody
                    );

                    form.submit();
                }
            } else {
                this.orderStatusModalMsg = undefined;
                this.createPaymentFail = true;
            }
        },
        redirectToOrderHistory(saleOrdTxnNum) {
            // Refresh Shopping Cart
            this.$store.dispatch('getShoppingCartList');
            this.$router.push({
                name: 'order',
                params: {
                    orderNo: saleOrdTxnNum
                },
                query: {
                    success: 'true'
                }
            });
        },
        async infoSaveSuccess() {
            this.showInfoModal = false;
            await this.requestConfirmOrder();
        }
    }
};
</script>
